(function () {
  'use strict';

  if (customElements.get('cos-countdown')) return;  

  class CosNotif extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const settings = JSON.parse(this.getAttribute('data-settings')) || {};
      this.storageVar = settings.storageVar || 'cos-notif' + settings.sectionId;
      try {
        if (localStorage.getItem(this.storageVar) === 'seen' && !settings.designMode) return;
      } catch (e) {
        // SecurityError can occur in sandbox/iframe contexts
      }

      if (settings.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          this.prepareNotif();
          if(e.detail.sectionId === settings.sectionId) {
            this.showNotif();
          } else {
            this.hideNotif();
          }
        });
        // document.addEventListener('shopify:section:load', (e) => {
        //   localStorage.clear(this.storageVar);
        // });
      } else {
        if (!settings.showSection) return;

        this.prepareNotif();
        setTimeout(() => {
          this.showNotif();
        }, settings.delay || 2000);
      }
    }

    prepareNotif() {
      const template = this.querySelector('template');
      const templateContent = template.content.cloneNode(true);

      templateContent.querySelector('[hide-notif]').addEventListener('click', () => {
        try {
          localStorage.setItem(this.storageVar, 'seen');
        } catch (e) {
          // SecurityError can occur in sandbox/iframe contexts
        }
        this.hideNotif();
      }); 

      this.appendChild(templateContent);
    }

    showNotif() {
      this.classList.add('show');
      this.isShowing = true;
    }
  
    hideNotif() {
      this.classList.remove('show');
      this.isShowing = false;
    }
  }
  customElements.define('cos-notif', CosNotif);
})();